module.exports = __webpack_public_path__ + "media/images/award_ribbon-3ef8aa74.png";